import { useRef, useMemo } from "react"
import * as THREE from "three"

interface FloorProps {
  position?: [number, number, number]
  width?: number
  length?: number
  color?: string
}

export function Floor({
  position = [0, 0, 0],
  width = 40,
  length = 10,
  color = "#656c76",
}: FloorProps) {
  const ref = useRef<THREE.Mesh>(null)

  const createGridMaterial = useMemo(() => {
    return new THREE.MeshStandardMaterial({
      color: new THREE.Color(color),
      roughness: 1,
      metalness: 0
    })
  }, [color])

  return (
    <mesh
      ref={ref}
      position={position}
      rotation={[-Math.PI / 2, 0, 0]}
      receiveShadow
      frustumCulled={true}
    >
      <planeGeometry
        key={`floor-${width}-${length}`}
        args={[width, length, 1, 1]}
    />
     
      <primitive object={createGridMaterial} />
    </mesh>
  )
}